export enum OnboardPlatform {
  CMP = 'cmp',
  CSP = 'csp',
}

export const OnboardPlatformList = [OnboardPlatform.CMP, OnboardPlatform.CSP];
